import * as Actions from "../action/TemplateAction";

const initialState = {
  templateData: null,
  categoryList: [],
};

const TemplateReducer = (state = initialState, action) => {
  switch (action?.type) {
    case Actions.UPDATE_TE_DATA: {
      return { ...state, templateData: action.payload };
    }
    case Actions.UPDATE_CATEGORY_DATA: {
      return { ...state, categoryList: action.payload };
    }
    case Actions.GET_TEMPLATE_LIST: {
      return { ...state, templateList: action.payload };
    }
    case Actions.ENABLE_GLOBAL_RATING: {
      if (!state.templateList) return state;
      return { ...state, templateList: { ...state.templateList, is_global_rating_enabled: action.payload } };
    }
    case Actions.GET_RATINGS_LIST: {
      // fetchCall hands error responses to the same callback, so a failed refetch must not replace a good cached pool.
      if (!Array.isArray(action.payload?.data)) return state;
      return { ...state, ratingsList: action.payload };
    }
    case Actions.REORDER_RATINGS_LIST: {
      const existingRatings = state.ratingsList?.data;
      if (!Array.isArray(existingRatings)) return state;
      const orderedIds = action.payload || [];
      const byId = new Map(existingRatings.map((rating) => [String(rating.id), rating]));
      const reordered = orderedIds.map((id) => byId.get(String(id))).filter(Boolean);
      const rest = existingRatings.filter((rating) => !orderedIds.some((id) => String(id) === String(rating.id)));
      return { ...state, ratingsList: { ...state.ratingsList, data: [...reordered, ...rest] } };
    }
    default: {
      return state;
    }
  }
};

export default TemplateReducer;
